export const FileArchiveTypesValues = [
    'UNKNOWN',
    'REPORT',
    'CONTESTANT_IMPORT',
    'DIPLOMA',
    'UPLOADED',
    'EVENTCREATE_EXTERNALDATASOURCE',
] as const;
export type FileArchiveTypes = (typeof FileArchiveTypesValues)[number];
